import { render, staticRenderFns } from "./ReviewItem.vue?vue&type=template&id=c3e1115a&scoped=true&"
import script from "./ReviewItem.vue?vue&type=script&lang=js&"
export * from "./ReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewItem.vue?vue&type=style&index=0&id=c3e1115a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e1115a",
  null
  
)

export default component.exports